/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type CreateMediaAssetInput = {
    readonly clientMutationId: string;
    readonly description?: string | null;
    readonly files?: ReadonlyArray<string> | null;
    readonly label?: string | null;
    readonly tags?: ReadonlyArray<string> | null;
    readonly topLevelMediaType?: TopLevelMediaKind | null;
};
export type createMediaAssetMutationVariables = {
    readonly input: CreateMediaAssetInput;
};
export type createMediaAssetMutationResponse = {
    readonly createMediaAsset: {
        readonly clientMutationId: string;
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly mediaAsset: {
            readonly id: string;
            readonly description: string | null;
            readonly files: ReadonlyArray<{
                readonly id: string;
            }> | null;
        } | null;
    } | null;
};
export type createMediaAssetMutation = {
    readonly response: createMediaAssetMutationResponse;
    readonly variables: createMediaAssetMutationVariables;
};



/*
mutation createMediaAssetMutation(
  $input: CreateMediaAssetInput!
) {
  createMediaAsset(input: $input) {
    clientMutationId
    hasErrors
    errors {
      id
      location
    }
    mediaAsset {
      id
      description
      files {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMediaAssetInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createMediaAsset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDeleteUpdateMediaAssetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mediaAsset",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaAsset",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "files",
            "storageKey": null,
            "args": null,
            "concreteType": "MediaAssetFile",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createMediaAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "createMediaAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "createMediaAssetMutation",
    "id": null,
    "text": "mutation createMediaAssetMutation(\n  $input: CreateMediaAssetInput!\n) {\n  createMediaAsset(input: $input) {\n    clientMutationId\n    hasErrors\n    errors {\n      id\n      location\n    }\n    mediaAsset {\n      id\n      description\n      files {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '19886e236f62652231dafd3f51eacb0b';
export default node;
